@if (notHidden && dataLoaded) {
  <nav class="navbar">
    <div class="container-fluid">
      <!-- ! LOGO -->
      <a appAnalytics="click" eventCategory="NAVBAR" eventAction="NAVBAR_ITEM_CLICK" eventLabel="Home"
        eventType="Chubb logo image" (click)="navigateHome()" class="logo navbar-logo"
        [ngClass]="{'removecursor': !showLogoForPartner()}">
        <img class="navbar-logo-chubb" src="{{logoURL(commonCommunicationService.navfontcolor)}}" alt="CHUBB">
      </a>
      <span class="navbar-logotext" id="navbar-logotext">{{logoText()}}</span>
      <!-- ! [x] hamburger -->
      <input class="menu-btn" type="checkbox" id="menu-btn" />
      <label class="menu-icon navbar-menu-icon" for="menu-btn">
        <span class="navicon-{{commonCommunicationService.navfontcolor}} navbar-menu-icon-item"></span>
      </label>
      <!-- ! menus -->
      @if (displayLeftNavsection) {
        <ul class="menu navbar-menu">
          @for (navItem of navContent.menuItems; track navItem) {
            <li class="navbar-menu-items">
              @if (navItem && navItem.subNavItems && (navItem.subNavItems.length === 0) && getShowMenuItemForPartner(navItem.partnersNotEligible)) {
                <a class="navbar-menu-items-links"
                  (click)="handleClickQuote(navItem.navigationURL, navItem.loadOnSamePage, navItem.text)" appAnalytics="click"
                  eventCategory="NAVBAR" eventAction="NAVBAR_ITEM_CLICK"
                  eventLabel="{{navItem.text}}">
                  @if (navItem.logo && (navItem.logo !== '')) {
                    <img class="logo" src="{{blobURL + navItem.logo}}">
                    }{{navItem.text}}
                  </a>
                }
                @if (navItem && navItem.subNavItems && (navItem.subNavItems.length > 0)) {
                  <input id="{{navItem.text}}" type="checkbox" name="menu" />
                }
                @if (navItem && navItem.subNavItems && (navItem.subNavItems.length > 0) && getShowMenuItemForPartner(navItem.partnersNotEligible)) {
                  <label class="navbar-menu-items-links"
                  for="{{navItem.text}}">{{navItem.text}}</label>
                }
                @if (navItem && navItem.subNavItems && (navItem.subNavItems.length > 0)) {
                  <ul class="sub-menu navbar-menu-items-dropdown">
                    @for (item of navItem.subNavItems; track item) {
                      <li class="navbar-menu-items-dropdown-items"
                        [ngClass]="{'hide-in-mobile' : (item.text === 'General Liability')}">
                        @if (!item.isPhoneLink && (item.navURL !== '') && getShowMenuItemForPartner(item.partnersNotEligible)) {
                          <a
                            class="navbar-menu-items-dropdown-items-dropdown-items-links" target="_blank"
                            (click)="handleClickQuote(item.navURL, item.loadOnSamePage)" appAnalytics="click"
                            eventCategory="NAVBAR" eventAction="NAVBAR_ITEM_CLICK" eventLabel="{{item.text}}">
                            {{item.text}}
                          </a>
                        }
                        @if (item.isPhoneLink && (item.navURL === '') && getShowMenuItemForPartner(item.partnersNotEligible, item.partnerSpecificContact)) {
                          <a
                            class="navbar-menu-items-dropdown-items-dropdown-items-links"
                            href="{{ callUsNumber.phoneNumberLink }}" (click)="handleClick()" appAnalytics="click"
                            eventCategory="NAVBAR" eventAction="NAVBAR_ITEM_CLICK" eventLabel="{{item.text}}">
                            {{item.text}}{{ callUsNumber.phoneNumber }}
                          </a>
                        }
                        @if (!item.isPhoneLink && (item.navURL === '') && getShowMenuItemForPartner(item.partnersNotEligible)) {
                          <a
                          class="hide-in-mobile navbar-menu-items-dropdown-items-links">{{item.text}}</a>
                        }
                        @if (item.childNavItems && (item.childNavItems.length > 0)) {
                          <ul
                            class="sub-menu-items navbar-menu-items-dropdown-items-dropdown">
                            @for (childItem of item.childNavItems; track childItem) {
                              <li
                                class="navbar-menu-items-dropdown-items-dropdown-items">
                                @if (getShowMenuItemForPartner(childItem.partnersNotEligible)) {
                                  <a
                                    class="navbar-menu-items-dropdown-items-dropdown-items-links" target="_blank"
                                    (click)="handleClickQuote(childItem.navURL, childItem.loadOnSamePage)"
                                    appAnalytics="click" eventCategory="NAVBAR" eventAction="NAVBAR_ITEM_CLICK"
                                    eventLabel="Claims Center">{{childItem.text}}
                                  </a>
                                }
                              </li>
                            }
                          </ul>
                        }
                      </li>
                    }
                  </ul>
                }
              </li>
            }
          </ul>
        }
      </div>
    </nav>
  }